<div class="insights-panel">
    <!-- Tab Navigation -->
    <div class="tab-navigation">
        <button
            *ngFor="let tab of tabs"
            class="tab-button"
            [class.active]="isActiveTab(tab.id)"
            (click)="setActiveTab(tab.id)"
        >
            {{ tab.label }}
        </button>
    </div>

    <!-- Tab Content -->
    <div class="tile-content">
        <!-- Current Schedule Tab -->
        <div *ngIf="isActiveTab('current-schedule')" class="tab-pane">
            <div class="insights-parent">
                <app-current-schedule-tile
                    [eventName]="'Vitamin C Booster'"
                    [eventPlace]="'Farm Beta - House B - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Scheduled'"
                    [assignedTo]="'James Thomas'"
                    [birdAge]="'Day 14'"
                ></app-current-schedule-tile>
                <app-current-schedule-tile
                    [eventName]="'Vitamin C Booster'"
                    [eventPlace]="'Farm Beta - House B - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Scheduled'"
                    [assignedTo]="'Mohammed'"
                    [birdAge]="'Day 14'"
                ></app-current-schedule-tile>
                <app-current-schedule-tile
                    [eventName]="'Vitamin C Booster'"
                    [eventPlace]="'Farm Beta - House B - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Scheduled'"
                    [assignedTo]="'Mohammed'"
                    [birdAge]="'Day 14'"
                ></app-current-schedule-tile>
            </div>
        </div>

        <!-- History Tab -->
        <div *ngIf="isActiveTab('history')" class="tab-pane">
            <div class="insights-parent">
                <app-history-tile
                    [eventName]="'Amoxicillin (Antibiotic)'"
                    [eventPlace]="'Farm Beta - House B - Partition 1'"
                    [dueDate]="'2024-06-27'"
                    [feedback]="
                        '500ml - Waterline - Applied during morning feed'
                    "
                    [eventStatus]="'Applied'"
                    [assignedTo]="'James Thomas'"
                ></app-history-tile>
                <app-history-tile
                    [eventName]="'Lasota Vaccine (Vaccine)'"
                    [eventPlace]="'Farm Beta - House B - Partition 1'"
                    [feedback]="
                        '1000 doses - Injectable - Newcastle disease prevention'
                    "
                    [dueDate]="'2024-06-27'"
                    [eventStatus]="'Applied'"
                    [assignedTo]="'Mohammed'"
                ></app-history-tile>
            </div>
        </div>

        <!-- Inventory Tab -->
        <div *ngIf="isActiveTab('inventory')" class="tab-pane">
            <div class="inventory-parent">
                <app-inventory-tile
                    [itemName]="'Amoxicillin'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Dec 2025'"
                    [stockStatus]="'Good'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'Vitamin C'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Oct 2025'"
                    [stockStatus]="'low'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'Lasota Vaccine'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Aug 2026'"
                    [stockStatus]="'Good'"
                >
                </app-inventory-tile>

                <app-inventory-tile
                    [itemName]="'Amoxicillin'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Dec 2025'"
                    [stockStatus]="'Critical'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'Vitamin C'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Oct 2025'"
                    [stockStatus]="'Critical'"
                >
                </app-inventory-tile>
                <app-inventory-tile
                    [itemName]="'Lasota Vaccine'"
                    [stock]="'2.5L'"
                    [expirationDate]="'Aug 2026'"
                    [stockStatus]="'Good'"
                >
                </app-inventory-tile>
            </div>
        </div>

        <!-- AI Insights Tab -->
        <div *ngIf="isActiveTab('ai-insights')" class="tab-pane">
            <div class="insights-parent">
                <app-ai-insight-tile
                    [insightColor]="'blue'"
                    [insightTitle]="'Recommendation'"
                    [insightInfo]="
                        'Vitamin A booster suggested for Partition 3 on Day 20 based on historical performance data.'
                    "
                >
                </app-ai-insight-tile>

                <app-ai-insight-tile
                    [insightColor]="'orange'"
                    [insightTitle]="'Pattern Detected'"
                    [insightInfo]="
                        'Cycles with early antibiotic intervention show 8% better FCR at harvest.'
                    "
                >
                </app-ai-insight-tile>

                <app-ai-insight-tile
                    [insightColor]="'green'"
                    [insightTitle]="'Success Metrics'"
                    [insightInfo]="
                        'Cycle B12 medication schedule led to 2.3% lower mortality compared to previous cycles.'
                    "
                >
                </app-ai-insight-tile>
            </div>
        </div>

        <!-- Timeline Tab -->
        <div *ngIf="isActiveTab('timeline')" class="tab-pane">
            <div class="insights-parent">
                <app-timeline-tile
                    [eventName]="'Amoxicillin Applied'"
                    [applyMethod]="'500ml via waterline'"
                    [applicationForm]="'drug'"
                    [assignedTo]="'James Thomas'"
                    [dayNumber]="18"
                ></app-timeline-tile>
                <app-timeline-tile
                    [eventName]="'Lasota Vaccine (Vaccine)'"
                    [applyMethod]="'1000 doses injectable'"
                    [applicationForm]="'vaccine'"
                    [assignedTo]="'Mohammed'"
                    [dayNumber]="16"
                ></app-timeline-tile>
                <app-timeline-tile
                    [eventName]="'Vitamin C Booster'"
                    [applyMethod]="'250ml oral administration'"
                    [applicationForm]="'drug'"
                    [assignedTo]="'Mohammed'"
                    [dayNumber]="14"
                ></app-timeline-tile>
            </div>
        </div>
    </div>
</div>
